import { fb } from "./firebaseconfig";
import { analytics } from "./firebaseconfig";

let db = fb.database();


// This is your plugin object. It can be exported to be used anywhere.
const SlinkPlugins = {
  // The install method is all that needs to exist on the plugin object.
  // It takes the global Vue object as well as user-defined options.
  install(Vue, options) {
    // We call Vue.mixin() here to inject functionality into all components.
    Vue.mixin({
      // Anything added to a mixin will be injected into all components.
      // In this case, the mounted() method runs when the component is added to the DOM.
      mounted() {
        //   console.log('Mounted!');
      },
      data() {
        return {
          iceLocation:null,
          loadingStatus: false,
          // dynamicMediaHeight:{'height':'0px', 'padding-top':'20px' },
          urlExists: false,
          notification: null,
          // gFetchedFavicon: null,
          gCustomSiteFavicon: null,
          isMobile: navigator.share,
          rowLabel: null,
          rowValue: null,
          slinkCanInLine: [
            // "QR Code",
            "Link Grid",
            "Carousel",
            "Rumble Player",
            "In-Line Text Block",
            "Gallery",
            "Castbox Player",
            "Mixer Player",
            "YouTube Player",
            "Vimeo Player",
            "SoundCloud Player",
            "MixCloud Player",
            "Spotify Player",
            "Text Block",
            "Embed",
            "Twitch Player",
            "Audio Player",
            "Video Player",
            "Apple Music Player",
            "Image",
            "Personal Statistics",
            "List",
            "Link Group",
            'TikTok Player',
            'Instagram Post',
            'Ko-fi Donation',
            'Opensea Embed',
            'Gumroad Product',
            "Tweet",
            "Whisper Box"
          ],
          arDimensions: {
            'YouTube Player'  : '16/9',
            'Instagram Post'  : '353.6/600',
            'TikTok Player'   : '346/710',

          },
          gSiteTemplate: {
            background: "white",
            base: "",
            color: "black",
            customsite: "",
            fa: "link",
            favicon: "",
            placeholder: "URL",
            site: "",
            standard: false,
            faviconFull: "0",
            adult: false,
            premium: false,
            mailchimp: false,
            suffix: "", 
            scratch: null,
          },
          activeChild: null,

          // gTravel
          travelTo: null,
          
          //gCreateCustomSite
          customNewSite: null
        };
      },
      computed: {
        groupSize:function(){
          return _.size(this.getGroups) >0 ? true : false;
        },
        
        getGroups() {
          return this.slinks ? this.slinks.filter(slink => slink.site === 'Link Group' || slink.site === 'Link Grid').sort((a, b) => a.order - b.order) : [];
        },
        messageCount:function(){
          return this.profile && this.profile.messages != undefined?  _.size(this.profile.messages)-1 :0;
        },
        
        cardCount() { // updated
          return this.userDetails.cards ? _.size(this.userDetails.cards) : 0;
        },
        
        quicklinks() {
          return this.profile ? this.slinks.filter(slink => slink.quicklink === true && slink.disabled !== true) : null;
        },
        
        getSensitiveUserPicture: function() {
          try{
            if (this.userDetails.picture) {
                // console.log('sensitive content', this.userDetails.picture)
                return this.userDetails.picture.replace('https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o','https://ik.imagekit.io/slink/tr:n-sensitiveContent')
            } 
            else {
              return (
                "https://ui-avatars.com/api/?color=fff&background=3f51b5&size=128&name=" + this.userDetails.name.substring(0, 1)
              );
            }
          } 
          catch (err) {
          }
        },
        
        getUserPicture: function() {  //updated 2020-11-20
          const { picture, userDetails } = this;

          console.log(picture)
          if (picture) {
            let imageKit = picture;
            if (userDetails.pictureSize) {
              // imageKit = imageKit.replace('https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o','https://ik.imagekit.io/slink/tr:n-profilepicture')
              // imageKit = imageKit.replace('https://cdn.myslink.app','https://ik.imagekit.io/slink/tr:n-profilepicture')
            } else if (userDetails.pictureAdult) {
              imageKit = imageKit.replace('https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o','https://ik.imagekit.io/slink/tr:n-blur')
              imageKit = imageKit.replace('https://cdn.myslink.app','https://ik.imagekit.io/slink/tr:n-blur')
            }
            return imageKit;
          } 
          return (
            // "/static/images/avatar.jpg"
            picture
          );
        },
        // getHeaderBackground: function() { //reduntant  2020-11-20
        //   try{
        //     return "background: " + this.userDetails.background;
        //   }
        //   catch(err){
        //   }
        // },
        getCustomFont: function() {
          if (this.profile && (this.customFont != null || (this.userDetails && this.userDetails.customFont))) {
            let customFont = this.userDetails.customFont.replace(/:wght@\d*/g, '').replace(/\+/g, ' ');
            customFont = customFont.split(":")
            customFont = customFont[0]
          // console.log(this.customFont, customFont)

            return {'font-family': customFont + ', sans-serif'}; // Fallback font added
          }
          else if (this.profile && (this.customHostedFont != null || (this.userDetails && this.userDetails.customHostedFont))) {
            return {'font-family': 'hostedFont, sans-serif'}; // Fallback font added

          }

          return {};
        },
        getAdminCustomFont:function(){
          // console.log('getAdminCustomFont',this.userDetails.customFont)
          return this.profile ? this.userDetails.customFont : null
        },
        
        getBackground() {
          console.log('getBackground', this.profile)
          if (!this.profile) return 'default_background_style'; // Replace with your default background style
          const filterMapping = {
            dark: 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), ',
            medium: 'linear-gradient(rgba(255, 255, 255, 0.25), rgba(255, 255, 255, 0.25)), ',
            light: 'linear-gradient(rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), '
          };
          if (this.profile.backgroundImage && (this.profile.account === 7 || this.profile.enableUpgrades)) {
            let backgroundImage = `url("${this.userContentCDN(this.profile.backgroundImage)}")`;
            if (this.profile.backgroundFilter && this.profile.backgroundFilter !== 'none') {
              backgroundImage = filterMapping[this.profile.backgroundFilter] + backgroundImage;
            }
            console.log('backgroundImage', backgroundImage)
            return backgroundImage;
          }
          this.profile.background2 = this.profile.background2 || "#ffffff";
          if (this.customFont) {
            return `font-family: ${this.userDetails.customFont}, cursive; background: linear-gradient(180deg, ${this.profile.background} 0%, ${this.profile.background2} 100%)`;
          }
          return `linear-gradient(180deg, ${this.profile.background} 0%, ${this.profile.background2} 100%)`;
        },
        
        getAvatarBackground: function() {
          try{
            return this.userDetails.account == 7 ? "3px solid " + this.userDetails.background : null;
          }
          catch(err){}
        },
        borderRadius: function() {
          try{
            return (
              // this.userDetails.account == 7 ||
              // this.userDetails.enableUpgrades) &&
              // this.userDetails.rounded &&
              !this.userDetails.fullScreen)
              ? "20px"
              : "0px";
            }
            catch(err){}
        },
        // fullScreenPadding: function() {
        //   try{
        //     return this.userDetails.fullScreen ? "0px" : "20px";
        //   }
        //   catch(err){}
        // }
        fullScreenPadding: function() {   //updated 2020-11-20
          return this.userDetails && this.userDetails.fullScreen ? "0px" : "20px";
        }
      },
      methods: {
        // getPageBackground() {
        //   console.log('runnin improved getPageBackground')
        //   try {
        //     let bg = {};
        //     if (this.profile.backgroundImage !== undefined && (this.userDetails.account === 7 || this.userDetails.enableUpgrades)) {
        //       bg.backgroundImage = `url("${this.userContentCDN(this.userDetails.backgroundImage)}")`;
        
        //       const filterMapping = {
        //         dark: 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), ',
        //         medium: 'linear-gradient(rgba(255, 255, 255, 0.25), rgba(255, 255, 255, 0.25)), ',
        //         light: 'linear-gradient(rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), '
        //       };
        
        //       if (this.userDetails.backgroundFilter && this.userDetails.backgroundFilter !== 'none') {
        //         bg.backgroundImage = filterMapping[this.userDetails.backgroundFilter] + bg.backgroundImage;
        //       }
        //       return bg;
        //     } else {
        //       if (!this.userDetails.background2) {
        //         this.userDetails.background2 = "#ffffff";
        //       }
        //       if (this.customFont) {
        //         bg['font-family'] = `${this.userDetails.customFont}, cursive;`;
        //       }
        //       const backgroundStyle = `background: linear-gradient(180deg, ${this.userDetails.background} 0%, ${this.userDetails.background2} 100%);`;
        //       return backgroundStyle;
        //     }
        //   } catch (err) {
        //     console.log('getBackground error', err);
        //   }
        // },
        
        // getPageBackground1: function(bgImage, bgFilter, bg1, bg2, account) {
        //   try{
        //     let self = this
        //     let bg = {};
        //     if(this.profile.backgroundImage != undefined &&(this.userDetails.account == 7 || this.userDetails.enableUpgrades)){
        //       bg.backgroundImage = 'url("'+this.userContentCDN(this.userDetails.backgroundImage) +'")'
        //       if(this.userDetails.backgroundFilter == null || this.userDetails.backgroundFilter == 'none'){

        //       }
        //       else if(this.userDetails.backgroundFilter == 'dark'){
        //         bg.backgroundImage = 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), '+ bg.backgroundImage
        //       }
        //       else if(this.userDetails.backgroundFilter == 'medium'){
        //         bg.backgroundImage = 'linear-gradient(rgba(255, 255, 255, 0.25), rgba(255, 255, 255, 0.25)), '+ bg.backgroundImage
        //       }
        //       else if(this.userDetails.backgroundFilter == 'light'){
        //         bg.backgroundImage = 'linear-gradient(rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), '+ bg.backgroundImage
        //       }
        //       return bg
        //     }
        //     else {
        //       let bg = {};
        //       if (this.userDetails.background2 == null || this.userDetails.background2 == undefined) {
        //         this.userDetails.background2 = "#ffffff";
        //       }
        //       let customFont = ''
        //       if(this.customFont != null){
        //         customFont = "font-family:"+ this.userDetails.customFont +", cursive;"
        //         bg['font-family'] = this.userDetails.customFont +", cursive;"
        //       }
        //       let b = "background: linear-gradient(180deg, "+this.userDetails.background +" 0%, " + this.userDetails.background2 + " 100%);"
        //       return (b);
        //     }
        //   }
        //   catch(err){
        //     console.log('getBackground error', err)
        //   }
        // },
        scheduleLink: function(linkid, event, date, user){
          db.ref('users/'+ user +'/links/'+ linkid+ '/'+event).transaction(function () {
            return date
          });
        },
        resetLinkScheduleDate: function(linkid, event, date, index){
          this.slinks[index][event] = ''
          db.ref('users/'+ this.activeUID +'/links/'+ linkid+ '/'+event).fbdb.transaction(function () {
            return ''
          });
        },
        slinkURLExists: function(url){
          // console.log('looking for', url)
          this.$bindAsArray("_urlExists",
            db.ref("url/").orderByChild("url").equalTo(url.toLowerCase()), null,() => {
              // console.log('matches found ####', this._urlExists.length)
              if(this._urlExists == 0){
                // console.log('nothing found')
                // this.urlExists = false
                return false
              }else{
                // console.log('found a match')
                // this.tempSettings.url = this.userDetails.url
                // if (this.updateSettings == null) {
                //   this.updateSettings = {};
                // }
                // this.updateSettings['url'] = this.userDetails.url;
                this.urlExists = true
                this.showNotification("This URL is already taken!");
                // console.log('url reset', this.userDetails.url, this.tempSettings.url)
                return true
              }

              return this.urlExists
            }
          )
        },
        userContentCDN: function(path){
          if(path.indexOf("firebasestorage.googleapis.com") != -1){
            path = path.replace("firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o", "cdn.myslink.app")
            // path = path.replace("firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o", "ik.imagekit.io/slink/")
          }
          return path
        },
        getDate: function(timestamp){
          let date = new Date(parseInt(timestamp));
          let formattedDate = date.getDate() + '/' + (date.getMonth()+1) + '/' + date.getFullYear()
          return(formattedDate);
        },
        getGroup: function(link){
          let groupedLink = this.slinks.filter(s => {
            return s.id == link
          })
          return groupedLink[0].group
        },
        
        inGroup(group, usage) { //updated
          let filteredLinks = this.slinks.filter(s => {
            if (usage) {
              return s.group === group;
            } else {
              return s.group === group && s.disabled !== true;
            }
          });
          if (this.userDetails.alphabetical) {
            return _.orderBy(filteredLinks, ["site"], ["asc"]);
          } else {
            return _.orderBy(filteredLinks, "order");
          }
        },
        
        getProfile: function(){
          // console.log('gettingAltProfile', this.userDetails.altProfile)

          // console.log('getProfile', this.userDetails.account)
          if(this.userDetails.account < 6){
            // console.log('getProfile', 'account not upgraded')
          }
          // console.log('getProfile', 'enableUpgrades',this.userDetails.enableUpgrades )

          if(this.userDetails.enableUpgrades == true){
            // console.log('getProfile', 'enableUpgrades',this.userDetails.enableUpgrades )
          }


          // if((this.userDetails.altProfile == 1 || this.userDetails.altProfile == 6 || this.userDetails.altProfile == 8) && (this.userDetails.account < 6 && this.userDetails.enableUpgrades == false)){
            // if((this.userDetails.altProfile == 1 || this.userDetails.altProfile == 6 || this.userDetails.altProfile == 8) && (this.userDetails.account < 6 && !this.userDetails.enableUpgrades)){
            // console.log('getProfile', this.userDetails.account, this.userDetails.altProfile)
            // return 0
          // }
          if((this.userDetails.altProfile == 18 || this.userDetails.altProfile == 19 || this.userDetails.altProfile == 11 || this.userDetails.altProfile == 3 || this.userDetails.altProfile == 2 || this.userDetails.altProfile == 9 || this.userDetails.altProfile == 4 || this.userDetails.altProfile == 7 || this.userDetails.altProfile == 10 || this.userDetails.altProfile == 13) && (this.userDetails.account < 7 && this.userDetails.enableUpgrades == false)){
          //  console.log('gettingAltProfile', this.userDetails.altProfile)
            return 0
          }
            // )
          // else if(this.userDetails.account != 7 && !this.userDetails.enableUpgrades){
          //   return 0
          // }
          else{
            if(this.withCard == false || this.userDetails.altProfileCard == undefined){
              return this.userDetails.altProfile
            }
            else{
              return this.userDetails.altProfileCard
            }
          }
        },
        errorImage: function(site){
          // console.log('Link', site, 'failaed to load icon')
          this.link.favicon = '../static/images/favicons/initial/' + site.slice(0, 1).toLowerCase() +'.png'
          this.link.faviconFull = true
      },
        getLinkExample(example){
          if (example == null || example == undefined){
            return ''
          }
          else{
            return 'eg ' + example
          }
        },
        setScratch(event){
          this.scratch = event.target.value
        },
        // updateUserProperty1(event){
        //   // console.log('updating property', event.target.name)
        //   let newValue = event.target.value
        //   let prop = event.target.name
        //   let self = this
        //   if (this.scratch != newValue){
        //     this.fbdb = db.ref('users/'+ this.targetUser + '/' + prop).transaction(function () {
        //       return newValue
        //     }).then( function(){
        //       self.showNotification(prop + " updated!");
        //     })
        //   }
        //   if (prop == "url"){
        //     this.fbdb = db.ref('url/'+ this.targetUser + '/' + prop).transaction(function () {
        //       return newValue
        //     })
        //   }
        //   this.scratch = null
        // },
        updateUserProperty(event) {               //updated
          let newValue = event.target.value;
          let prop = event.target.name;
          let self = this;
          if (this.scratch !== newValue) {
            db.ref(`users/${this.targetUser}/${prop}`).transaction(() => newValue)
              .then(() => {
                self.showNotification(`${prop} updated!`);
              });
            if (prop === "url") {
              db.ref(`url/${this.targetUser}/${prop}`).transaction(() => newValue);
            }
          }
          this.scratch = null;
        },
        
        // updateLinkProperty(linkid, property, value){
        //   this.fbdb = db.ref('users/'+ this.activeUID + '/links/' + linkid +'/'+property).transaction(function () {
        //     return value
        //   }).then( function(){
        //     // self.showNotification("Slink updated!");
        //   })
        // },
        updateLinkProperty(linkid, property, value) {         //updated
          console.log(linkid, property, value )
          db.ref(`users/${this.activeUID}/links/${linkid}/${property}`)
            .transaction(() => value);
        },


        updateGroup(linkid, groupid, groupOrder){
          // console.log('updating group')
          this.fbdb = db.ref('users/'+ this.activeUID + '/links/' + linkid +'/group').transaction(function () {
            return groupid
          }).then( function(){
            // self.showNotification("Slink updated!");
          })
        },
        // updateSlinkDetails(event){
        //   // console.log('#####', event)
        //   let newValue = event.target.value.trim()
        //   let prop = event.target.name
        //   let slink = event.target.id
        //   let site = event.target.alt

        //   if(prop == 'background'){
        //     this.activeEditLink.background = newValue
        //   }

        //   if (this.scratch !== newValue) {
        //     db.ref(`users/${this.activeUID}/links/${slink}/${prop}`)
        //       .transaction(() => newValue)
        //       .then(() => {
        //         this.showNotification("Slink updated!");
        //       });
        //     this.scratch = null;
        //     this.gGALog(this.userDetails.url, 'Update Slink', `${site}: ${prop}`);
        //   }
        // }, 
        updateSlinkDetails(event) {     // updated
          console.log(event)
          let newValue = event.target.value.trim();
          let prop = event.target.name;
          let slink = event.target.id;
          let site = event.target.alt;
          if (prop === 'background') {
            this.activeEditLink.background = newValue;
          }
        
          if (this.scratch !== newValue) {
            db.ref(`users/${this.activeUID}/links/${slink}/${prop}`)
              .transaction(() => newValue)
              .then(() => {
                this.showNotification("Slink updated!");
                this.scratch = null;
                this.gGALog(this.userDetails.url, 'Update Slink', `${site}: ${prop}`);
              });
          }
        },
        
        reorder(event) {    //updated
          this.slinks.forEach((slink, index) => {
            const updatedOrder = index;
            db.ref(`users/${this.activeUID}/links/${slink.id}`).update({ order: updatedOrder });
          });
          this.gGALog(this.userDetails.url, 'Re-Ordered', event.moved.element.site);
        },
        
        superReorder(event){
          const movedLink = event.moved.element.id
          const oldIndex = event.moved.oldIndex
          const newIndex = event.moved.newIndex
          let changes = []
          for (var i in this.slinks){
            changes[i] = {'key': this.slinks[i].id, 'order': i}
          }
          for(var c in changes){
            this.fbdb = db.ref('users/'+ this.targetUser +'/links/'+ changes[c].key).update({ order: parseInt(changes[c].order) });
          }
          this.gGALog(this.userDetails.url, 'Re-Ordered', event.moved.element.site)
        },
        addListRow(label, value){
          let newRow = {'value': value}
          // console.log(newRow)
          // console.log('#',this.newSlinkSite.template,'#')
          // this.newSlinkSite.template[label] = {'value':value}
          this.newSlinkSite.template[label] = value
          // this.newSlinkSite.template[label]
          // if( this.newSlinkSite.template == ''){
          //   this.newSlinkSite.template = []
          // // console.log('array',this.newSlinkSite.template,'#')
          // // this.newSlinkSite.template[label] = {'value':value}


          // this.newSlinkSite.template.push({[label]:newRow})
          // // this.newSlinkSite.template = {[label]:newRow}
          // console.log(this.newSlinkSite.template)
          // }
          // else{
          //   this.newSlinkSite.template[label].value = value
          // }
        },
        gOpenDialog: function(ref){
          this.$refs[ref].open();
        },
        gCloseDialog: function(ref){
          this.$refs[ref].close();
        },
        gCancelSub: function(uid, subid){
          // console.log('Closed', type);
          // this.gCloseDialog('cancelSubDialog')
          let self = this
          this.fbdb = db.ref('users/'+ uid +'/stripeCancel').transaction(function () {
            return subid
          }).then(function(){
            // console.log('has been downgraded to a Free account')
            self.gGALog(self.userDetails.url, "Billing", "Subscription Cancelled");
            this.fbdb = db.ref('users/'+ i + '/messages/').push({message:'Processing subscription cancellation.'})
            self.showNotification("Subscription cancellation in progress!");
          });
        },
        deleteMessage: function(uid, messageid){
          db.ref("/users/" + uid +"/messages/"+messageid).remove();
          this.gGALog(this.userDetails.url, "Messages", "Deleted");
          if(this.userDetails.messages.length == 1){
            db.ref("/users/" + uid +"/messages/").update({unread:false})
          }
        },
        imageKit: function(url, usage, ignore){
          // if statements for different image types, normal, gallery thumbnail, icon

          // https://storage.googleapis.com/download/storage/v1/b/slink-64a53.appspot.com/o/userContent%2FYYZKhL3N2SfE2zRwOwCDoIlqDSp2%2Fprofile?generation=1666049636405117&alt=media
          // let transformation = null
          let imageKitURL = url

          imageKitURL = imageKitURL. replace('https://storage.googleapis.com/download/storage/v1/b/slink-64a53.appspot.com/o','https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o')
          if(ignore == true){
            return url
          }
          else{
          if (usage == 'adminThumbnail'){
            imageKitURL = imageKitURL.replace('https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o','https://ik.imagekit.io/slink/tr:n-admin_preview')
          }
          else if(usage == 'vcf'){
            imageKitURL = imageKitURL.replace('https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o','https://ik.imagekit.io/slink/tr:n-vcf')
          }
          else if(usage == 'profilepicture'){
            imageKitURL = imageKitURL.replace('https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o','https://ik.imagekit.io/slink/tr:n-profilepicture')
          }
          else if(usage == 'favicon'){
            imageKitURL = imageKitURL.replace('https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o','https://ik.imagekit.io/slink/tr:n-favicon')
          }
          else if(usage == '9cube'){
            imageKitURL = imageKitURL.replace('https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o','https://ik.imagekit.io/slink/tr:n-9cube')
          }
          else if(usage == '9cubethumb'){
            imageKitURL = imageKitURL.replace('https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o','https://ik.imagekit.io/slink/tr:n-media_library_thumbnail  ')
          }
          imageKitURL = imageKitURL.replace('https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o','https://ik.imagekit.io/slink/tr:w-'+window.screen.width+',q:75')
          imageKitURL = imageKitURL.replace('https://source.unsplash.com','https://ik.imagekit.io/slink/slinkunsplash/tr:n-media_library_thumbnail')
          return imageKitURL
          // return imageKitURL
        }

        },
        companyLogoUpload(event, uid) {
          let updatePic = event[0]
          let extension = updatePic.name.substring(updatePic.name.indexOf("."))
          // console.log(updatePic.name, extension)
          this.loadingStatus = true
          let self = this
          var uploadTask = fb.storage().ref('userContent/'+uid+'/companyLogo').put(updatePic);
          uploadTask.on('state_changed', function(snapshot){
            var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            // console.log('Upload is ' + progress + '% done');
            self.loadingPicProgress = progress
            // console.log('progres', progress)
          }, function(error) {
            console.log(error)
          }, function() {
            uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
              let profilefbdb =  db.ref('users/'+uid +'/business/companyLogo');
              profilefbdb.transaction(function () {
                return downloadURL
              }).then(function(){
                // self.gGALog(self.userDetails.url, "Profile updated", 'picture');
                self.loadingStatus = false;
                // self.tempSettings.picture = downloadURL
                // self.loadingPicProgress = null
              });
            });
          });
        },
        pictureUpload(event, uid) {
          let updatePic = event[0]
          let extension = updatePic.name.substring(updatePic.name.indexOf("."))
          // console.log(updatePic.name, extension)
          this.loadingStatus = true
          let self = this
          var uploadTask = fb.storage().ref('userContent/'+uid+'/profile').put(updatePic);
          uploadTask.on('state_changed', function(snapshot){
            var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            // console.log('Upload is ' + progress + '% done');
            self.loadingPicProgress = progress
            // console.log('progres', progress)
          }, function(error) {
            console.log(error)
          }, function() {
            uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
              let profilefbdb =  db.ref('users/'+uid +'/picture');
              profilefbdb.transaction(function () {
                return downloadURL
              }).then(function(){
                self.gGALog(self.userDetails.url, "Profile updated", 'picture');
                self.loadingStatus = false;
                self.tempSettings.picture = downloadURL
                // self.loadingPicProgress = null
              });
            });
          });
        },
        imageUpload(event, uid) {
          let updatePic = event[0]
          this.loadingStatus = true
          this.loadingPicProgress = 0
          let self = this
          var d = new Date();
          var t = d.getTime();
          var uploadTask = fb.storage().ref('userContent/'+uid+'/images/'+ t).put(updatePic);
          uploadTask.on('state_changed', function(snapshot){
            var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            // console.log('Upload is ' + progress + '% done');
            self.loadingPicProgress = progress
          }, function(error) {
            console.log(error)
          }, function() {
            uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
              self.loadingStatus = false
              self.newSlinkSite.user = downloadURL
              self.newSlinkSite.imagePath = downloadURL
              self.loadingStatus = false
            });
          });
        },
        cancelImageUpload(site, image){
          if(site == 'Image'){
            this.imageDelete(window.decodeURIComponent(image))
          }
        },
        getLocation(){

          if (this.userDetails.ice && navigator.geolocation) {
            
            navigator.geolocation.watchPosition(this.showPosition,null,{enableHighAccuracy: true, maximumAge: 6000, timeout:60000})
          } else {
            console.log("Geolocation is not supported by this browser.")
          }
        },
        deletePage: function(uid, source){
          var setType =  db.ref('users/'+ uid + '/delete');
          setType.transaction(function (current_value) {
              return true
          });
          if(source == 'admin'){
            fb.auth().signOut().then(() => {
              this.$router.replace({ name: "Home" });
            });
          }
    
        }, 
        showPosition(position){
          this.iceLocation = position.coords.latitude + ', ' + position.coords.longitude
          let locatedName = this.profile[0].name
          let self = this
          // let self = this
          
          this.fbdb = db.ref("users/" + this.profile[0]['.key'] + "/iceLocation");
          // console.log('db', this.fbdb.ref )
          this.fbdb.transaction(function(current_value) {
            // console.log('gtoggleProperty',property, !current_value)
            return {latitude:position.coords.latitude, longitude:position.coords.longitude, name:locatedName, contact: self.profile[0].iceContact};
          });

          // console.log('Position', this.iceLocation )
          
        },
        imageDelete(image)
        {
          console.log(image)
          if(image.indexOf('firebase') != -1){
            image = window.decodeURIComponent(image)
            var pathPattern = new RegExp(/userContent\/.*\/\d*/i)
            image = window.decodeURIComponent(pathPattern.exec(image))
            var deleteTask = fb.storage().ref(image).delete().then(function() {
              // File deleted successfully
            }).catch(function(error) {
              // Uh-oh, an error occurred!
            });
          }
          else{
            console.log('no standard image')
          }
        },
        scrollTo(id){
          let moveTo = document.querySelector(id).getBoundingClientRect()
          window.scrollTo(moveTo.left, moveTo.top + window.scrollY - 62);
        },
        mediaHeight: function(id, site, definedHeight){
          if(site == 'YouTube Player' || site =='Vimeo Player'){
          this.$nextTick(() => {
            document.getElementById(id).style.height= (document.getElementById(id).clientWidth /1.77)+'px'
            document.getElementById(id).style.minHeight= null
           });
           return
          }
          else if(site == 'TikTok Player'){
            this.$nextTick(() => {
              // document.getElementById(id).style.height= (document.getElementById(id).clientWidth /1.77)+'px'
              document.getElementById(id).style['aspect-ratio'] = 9/16
              // document.getElementById(id).style.minHeight= null
             });
             return
          }
          else if(site == 'galleryThumb'){
            this.$nextTick(() => {
              // console.log(id, 'imagewidth:',document.getElementById(id).clientWidth)
              document.getElementById(id).style.height= (document.getElementById(id).clientWidth)+'px'
             });
             return
            }
            else{
              this.$nextTick(() => {
              try{
                let height = null
                let res = definedHeight.match(/\bheight[=:"]*\d*/g)
                height = res[0].replace(/\bheight[=:"]*/g, '').concat('px')
                document.getElementById(id).style.height= height
              }
              catch (e){
                console.log('embed height error', e)
              }        
            });
          }
        },
        listOrder: function(list){
          return _.orderBy(list, "order");
        },
        imageApproved: function(safeSearch){
          if (
            safeSearch.adult === 'VERY_LIKELY' ||
            // safeSearch.spoof !== VERY_UNLIKELY ||
            // safeSearch.medical !== VERY_LIKELY ||
            safeSearch.violence === 'VERY_LIKELY' ||
            safeSearch.racy === 'VERY_LIKELY'
          ){
            return false
          }
          else{
            return true
          }
        }, 
        readMessages: function(uid) {
          this.fbdb = db.ref("users/" + uid + "/messages/unread");
          this.fbdb.transaction(function(current_value) {
            return false;
          });
          this.gGALog(this.userDetails.url, "Messages", "Read");
        },
        resetPageViews: function(uid) {
          this.fbdb = db.ref("users/" + uid + "/pageViews");
          this.fbdb.transaction(function(current_value) {
            return 0;
          });
        },
        resetCoins: function(uid) {
          this.fbdb = db.ref("users/" + uid + "/slinkCoins");
          this.fbdb.transaction(function(current_value) {
            return null;
          });

          this.fbdb = db.ref("users/" + uid + "/coinStatement");
          this.fbdb.transaction(function(current_value) {
            return null;
          });
        },
        deleteChild: function(uid) {
          db.ref("/users/" + uid).remove();
          db.ref("/url/" + uid).remove();
          this.showNotification("Page Deleted!");
        },
        webShare: function() {
          if (navigator.share) {
            navigator.share({
              title: "Slink - Digital Business Card",
              text: "Check out " + this.userDetails.name + "'s social media and websites on their Slink Digital Business Card",
              url: 'https://MySlink.app/' + this.userDetails.url
            });
          } else {
            console.log("provide a fallback here");
          }
        },
        getSlinkCanInLine: function(site) {
          let x = this.slinkCanInLine.indexOf(site);
          if (x != -1) {
            return true;
          }
        },
        gGetMJid(email, uid){
          console.log("gGetMJid",  email, uid)
          let mData = JSON.stringify({ 
            email: email,
            uid: uid
          })
          console.log(mData)
          fetch("https://751fb4c3267275903c75b95dc595d25f.m.pipedream.net", {
            cache: "no-cache",
            credentials: "same-origin",
            headers: { "user-agent": "Mozilla/4.0 MDN Example",'Content-Type': 'application/json' },
            method: "POST",
            mode: "no-cors",
            redirect: "follow",
            referrer: "no-referrer",
            body: mData
          })
        },
        gGetFavicon(domain) {
          let self = this;
          fetch("https://favicongrabber.com/api/grab/" + domain).then(function(
            response
          ) {
            response.json().then(function(data) {
              self.gCustomSiteFavicon = data.icons[0].src;
              return self.gCustomSiteFavicon;
            });
          });
        },
        gTravel(base, details, suffix) {
          // console.log(base, details, suffix)
          this.travelTo = base + details.trim() + suffix;
          if (this.travelTo != "undefined"  && base != 'QR Code') {
            if (this.travelTo.indexOf(":") == -1) {
              this.travelTo = "http://" + this.travelTo;
            }
            if(this.userDetails.warning != true){
              if (
                (this.travelTo.indexOf("mailto:") != -1 ||
                this.travelTo.indexOf("tel:") != -1)
              ) {
                window.location.assign(this.travelTo);
              } else {
                window.open(this.travelTo);
              }
            }
          }
        },
        openExternal(url) {
          // console.log(base, details, suffix)
          // this.travelTo = base + details.trim() + suffix;
          // if (this.travelTo != "undefined"  && base != 'QR Code') {
          //   if (this.travelTo.indexOf(":") == -1) {
          //     this.travelTo = "http://" + this.travelTo;
          //   }
          //   if(this.userDetails.warning != true){
          //     if (
          //       (this.travelTo.indexOf("mailto:") != -1 ||
          //       this.travelTo.indexOf("tel:") != -1)
          //     ) {
          //       window.location.assign(this.travelTo);
          //     } else {
            // this.gGALog(this.userDetails.url, "External URL", url)
        // this.gFBALog('External URL', {'site':url, 'details':this.userDetails.url})
                window.open(url);
          //     }
          //   }
          // }
        },
        // editContent(evt){
        //   console.log('before',evt.target.innerText,'#')          
        // },
        updateProperty(evt){
          // console.log('after: #',evt.target.innerText,'#')
          let newContent = evt.target.innerText
          db.ref("users/" + this.activeUID + "/" + evt.target.id).transaction(function(current_value) {
            // console.log('after: #', newContent,'#fb')
            return newContent;
          });
        },
        // gMailchimpTag(user, tag) { //redundant
        //   let mData = user + ":" + tag;
        //   fetch("../api/addTags", {
        //     cache: "no-cache",
        //     credentials: "same-origin",
        //     headers: { "user-agent": "Mozilla/4.0 MDN Example" },
        //     method: "POST",
        //     mode: "no-cors",
        //     redirect: "follow",
        //     referrer: "no-referrer",
        //     body: mData
        //   })
        //     .then(res => res.json())
        //     .then(json => console.log(json));
        // },
        gCreateCustomSite(site, domain, favicon) {
          // console.log("gcreatecustomsite");
          this.customNewSite = this.gSiteTemplate;
          this.customNewSite.favicon = favicon;
          this.customNewSite.customsite = domain;
          this.customNewSite.site = domain.charAt(0).toUpperCase() + domain.slice(1);
          db.ref("customsite/").push(this.customNewSite);
          let createdSite = [];
          createdSite.push(this.customNewSite);
          return createdSite;
        },
        
        failedIcon(event) {
          // console.log('failedIcon', event.target.id)
          event.target.style.width = "100%";
          event.target.style.height = "100%";
          event.target.style.objectFit = "contain";
          // event.target.src = 'https://ui-avatars.com/api/?bold=true&background=fff&color=000&length=1&size=128&name='+event.target.id
          event.target.src =
            "../static/images/favicons/initial/" +
            event.target.id.slice(0, 1).toLowerCase() +
            ".png";
          // event.target.style.marginLeft = "inherit";
          // event.target.style.marginRight = "inherit";
          // event.target.style.marginTop = "unset";
          event.target.style.margin = "8px auto";
          
          return "/static/images/favicons/link.png";
        },
        logout: function() {
          this.gGALog(this.userDetails.url, "Logout", "Logged Off");
          fb.auth().signOut().then(() => {
              this.$router.replace({ name: "Home" });
            });
        },
        gGALog(category, action, label, value, url) {
          this.$ga.event({
            eventCategory: category,
            eventAction: action,
            eventLabel: label,
            eventValue: value
          });
        },
        gFBALog(event, params){
          analytics.logEvent(event, params);
          // console.log('gFBALog', event, params)
        },
        fullColourButtons: function(background, usage) {
          // console.log('fcb', background)

          let bg = background
          if (background == undefined){
            background = '#ffffff'
          }
          if(this.userDetails.fullColourButtons && background.indexOf("#") == 0 && (this.userDetails.account == 7 || this.userDetails.enableUpgrades)){
            bg = background 
            // console.log('full colour', background)
          }
          else{
            bg = '#ffffff'
          }
          
          if(this.userDetails.backgroundImage){
            console.log('has background image')
            bg = this.userDetails.buttonGlass == false ? bg: bg + 'BF'
            // bg= buttonGlass == false ? bg: bg + 'BF'
            
          }
          if(usage == 'socialShare')
          {
            // console.log('socialShareColour', background)
            bg = background
          }
          return bg
          // return this.userDetails.fullColourButtons && background.indexOf("#") == 0 && (this.userDetails.account == 7 || this.userDetails.enableUpgrades)
          //   ? background
          //   : "#ffffff";
        },
        fullColourButtonsText: function(background, ForceTextColour, color, usage) {
          // if(background == undefined && usage == 'footer'){
          //   background = '#000000'
          //   console.log('fcbt', background, usage)
          // }
          // console.log(event)
          if (background == undefined || background == 'white'){
            background = '#ffffff'
          }
          if(ForceTextColour){
            return color
          }
          else if ((this.userDetails.fullColourButtons || usage == 'colorPicker') && (this.userDetails.account == 7 || this.userDetails.enableUpgrades || usage == 'socialShare' || usage == 'colorPicker') || usage == 'footer' || usage == 'slinkcarddemo'){
            var r = parseInt(background.substr(1,2), 16); // Grab the hex representation of red (chars 1-2) and convert to decimal (base 10).
            var g = parseInt(background.substr(3,2), 16);
            var b = parseInt(background.substr(5,2), 16);

            // r /= 255, g /= 255, b /= 255;
            // var max = Math.max(r, g, b), min = Math.min(r, g, b);
            // var l = (max + min) / 2;
            // var h, s, l = (max + min) / 2;

            // if(max == min){
            //     h = s = 0; // achromatic
            // }else{
            //     var d = max - min;
            //     s = l > 0.51 ? d / (2 - max - min) : d / (max + min);
            //     switch(max){
            //         case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            //         case g: h = (b - r) / d + 2; break;
            //         case b: h = (r - g) / d + 4; break;
            //     }
            //     h /= 6;
            // }
            // var c = Math.round((l -1)) *-100
            // var text = "hsl(0,0%,"+c+"%)"
            // console.log('text color:',"hsl(0,0%,"+ (Math.round((l -1)) *-100)+"%)", r,g,b, l)
            // console.log('text colour', background, "hsl(0,0%,"+ (Math.round((l -1)) *-100)+"%)")
            // return "hsl(0,0%,"+ (Math.round((l -1)) *-100)+"%)"
            var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
        return (yiq >= 128) ? '#000000' : '#ffffff';
        // r /= 255, g /= 255, b /= 255;
        // var max = Math.max(r, g, b), min = Math.min(r, g, b);
        // var l = (max + min) / 2;
        // return "hsl(0,0%,"+ (Math.round((l -1)) *-100)+"%)"
          }
          else{
            return '#000000'
          }

          // return this.userDetails.fullColourButtons &&
          //   background.indexOf("#") == 0
          //   ? "#ffffff"
          //   : "#000000";
        },
        // showQuicklink: function(state) { //redundant
        //   return (this.userDetails.quicklink == true && state == true) ? false : true;
        // },
        // gFetchRSS() {
          // this.gGALog('test', 'test','test',null,'test')
          // let feed = []
          // console.log('fetching rss')
          // let x =  fetch('https://cors-anywhere.herokuapp.com/https://www.youtube.com/feeds/videos.xml?channel_id=UCP4bf6IHJJQehibu6ai__cg').then(
          //    function(response) {
          //        console.log(response)
          //        response.json().then(function(data) {
          //         console.log(data);
          //       });
          //    }
          //  )
          // console.log(this.gUserDetails.url);
        // },
        // gUpdateMailchimpID: function(uid, email) {
        //   let self = this;
          // fetch("https://helloacm.com/api/md5/?s=" + email).then(function(
          //   response
          // ) {
          //   response.json().then(function(data) {
          //     console.log("md5", email, data);
          //     db.ref("users/" + uid).update({ mailchimpID: data });
          //   });
          // });
        // },
        gtoggleProperty(property, uid, profileKey, url) {
          db.ref("users/" + uid + "/" + property).transaction(function(current_value) {
            return !current_value;
          });
          this.gGALog(url, "Profile updated", property);
        },
        gUpdateProperty(property, value, uid, profileKey, url) {
          this.fbdb = db.ref("users/" + uid + "/" + property);
          this.fbdb.transaction(function(current_value) {
            return value;
          });
          this.gGALog(url, "Profile updated", property);
        },
        pushSlink(uid, url, site) {
          delete site['.key']
          this.fbdb = db.ref("users/" + uid + "/links/").push(site);
          this.showNotification("Slink Added!");
          this.gaLog(url + " (Admin)", "Add Slink", site.site);
        },
        // gUpdateSlink(uid, link, properties) {      // redundant
        //   this.fbdb = db.ref("users/" + uid + "links/" + link);
        //   this.fbdb.transaction(function(current_value) {
        //   });
        // },
        showNotification(message) {
          this.notification = message;
          this.$refs.snackbar.open();
        },
        showUpgradeNotification(message) {
          this.notification = message;
          this.$refs.upgradesnackbar.open();
          // console.log("upgrade notification");
        },
        gDeleteSlink(uid, key, link, url) {
          this.fbdb = db.ref("users/" + uid + "/links/" + key)
            .remove()
            .then(function() {
              // console.log("Remove succeeded.")
              // traverse slink array to fi
            })
            .catch(function(error) {
              console.log("Remove failed: " + error.message);
            });
          this.gGALog(url, "Deleted Slink", link);
          this.showNotification("Slink Deleted!");
        },
        // gDisableSlink: function(uid, key) {
        //   this.fbdb = db.ref("users/" + uid + "/links/" + key + "/disabled");
        //   this.fbdb.transaction(function(current_value) {
        //     return !current_value;
        //   });
        // },
        gLinkProperties: function(uid, key, property) {
          this.fbdb = db.ref("users/" + uid + "/links/" + key + "/" + property + "/");
          this.fbdb.transaction(function(current_value) {
            return !current_value;
          });
        },
        gCreateNewUser(uid, user) {
          // console.log("gCreateNewUser");
          let newUID = uid + "_" + user.toLowerCase();
          let url = user.replace(/\s/g, "").toLowerCase();

          if (user != null) {
            this.fbdb = db.ref("users/" + newUID + "/profile/").push({
              name: user,
              //   name: user.toLowerCase(),
              picture:
                "https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o/Profile%20Pictures%2Fdefaultprofilepic.jpg?alt=media&token=ae91f354-bb14-490a-9577-fa3aff108a23",
              url: url,
              account: 0,
              onboarding: false
            });
            this.fbdb = db.ref("users/" + newUID).update({ url: url }); //.then(_ => console.log("url updated in userlinks"));
            this.fbdb = db.ref("url/" + newUID).update({ url: url });
            // this.slack(uid, email)
            // this.showNotification('New user '+ user + ' created!')
          } else {
            //   this.showNotification('New user name was empty!')
          }
          return newUID;
        },
        gCreateNewPage(page, parentProfileKey) {
          // console.log("gCreateNewPage", page);
          let newUID = page.parent + "_" + page.url;
          page.url =
            page.url +
            Math.random()
              .toString(36)
              .substring(4, 8);



          // page.url = this.gURLExists(page.url)
          // console.log('output', this.gURLExists(page.url))
          // if (this.gURLExists(page.url)){
          //     page.url = page.url + '_' +page.parent.substring(0, 4).toLowerCase()
          // }
          // console.log('creating:', newUID, page.name, page.url)

          this.fbdb = db.ref("users/" + newUID + "/profile/").push(page);
          this.fbdb = db.ref("users/" + newUID).update({ url: page.url }); //.then(_ => console.log("url updated in userlinks"));
          this.fbdb = db.ref("url/" + newUID).update({ url: page.url });

          var nc = {};
          nc[newUID] = page.name;
          this.fbdb = db.ref("users/" + this.parentUID + "/profile/" + parentProfileKey + "/children").update(nc);
          return newUID;
        },
        gURLExists: function(url) {
          // console.log("checking for:", "#" + url + "#");
          let exists = false;
          var u = null;
          var self = this;

          if (this._urlExists == undefined) {
            // console.log("prefetch, _urlExists is undefined");

            this.$bindAsArray(
              "_urlExists",
              db
                .ref("url/")
                .orderByChild("url")
                .equalTo(url.toLowerCase()),
              null,
              () => {
                this.$bindAsArray(
                  "_urlExists",
                  db
                    .ref("url/")
                    .orderByChild("url")
                    .equalTo(url.toLowerCase()),
                  null,
                  () => {
                    for (var i in this._urlExists) {
                      // console.log(this._urlExists[i].url);
                      exists = true;
                    }
                  }
                );
              }
            );
          } else {
            this.$bindAsArray(
              "_urlExists",
              db
                .ref("url/")
                .orderByChild("url")
                .equalTo(url.toLowerCase()),
              null,
              () => {
                // console.log('#1', 'length',this._urlExists, this._urlExists.length)
                // console.log('#2', 'length',self._urlExists, self._urlExists.length)
                //    console.log('###', result)
                for (var i in this._urlExists) {
                  // console.log(this._urlExists[i].url);
                  self.urlExists = true;
                  exists = true;

                  // return true
                  // exists = true
                  // return exists
                  // if(i != '.key' && i != '.value' ){
                  //     u = this._urlExists[i].url
                  //     exists = true
                  //     return true
                  // }
                }
                // if(this._urlExists.length == 1){
                //     exists = true
                //     return true
                // }
                // else{
                //     console.log('pooh')
                // }
                // this.$unbind('_urlExists')
                // return exists
              }
            );
          }

          // this.$unbind('_urlExists')
          // console.log('URL:',url, 'exists:', exists, this._urlExists.length)
          // console.log('u', u)

          // return this.urlExists
          return exists;
        },
        // copyDetails: function(toCopy) {

        //   this.$clipboard(toCopy);
        //   this.showNotification("Copied to Clipboard");
        // },
        copy(toCopy){
          this.$clipboard(toCopy);
          this.showNotification("Copied to Clipboard");
        },
        gGetAccountFeatures(account) {
          var features = [];
          if (account == 0) {
            features.description =
              "Free account: Unlimited links can be added to your Slink page. Custom labels are enabled. Custom descriptions are not enabled.";
            features.type = "Slink Free";
            features.customDescription = false;
          }
          // Not Assigned
          if (account == 1) {
            features.description = "";
            features.type = "";
            features.customDescription = false;
          }
          // // Not Assigned
          if (account == 2) {
            features.description = "";
            features.type = "";
            features.customDescription = false;
          }
          // Not Assigned
          if (account == 3) {
            features.description = "";
            features.type = "";
            features.customDescription = false;
          }
          // Not Assigned
          if (account == 4) {
            features.description = "";
            features.type = "";
            features.customDescription = false;
          }
          // Early Adopters Alpha - low impact
          if (account == 5) {
            features.description = "Slink Free Upgrade";
            features.type = "Slink Free Upgrade";
            // features.limit = 20;
            features.customDescription = true;
            // features.footer = true;
          }
          if (account == 6) {
            features.description = "Slink Plus";
            features.type = "Slink Plus";
            features.customDescription = true;
          }
          if (account == 7) {
            features.description = "Slink Premium";
            features.type = "Slink Premium";
            features.customDescription = true;
          }
          if (account == 8) {
            features.description = "Slink Enterprise";
            features.type = "Slink Enterprise";
            features.customDescription = true;
          }
          return features;
        }
      }
    });
  }
};
export default SlinkPlugins;


// WEBPACK FOOTER //
// ./src/components/plugins.js